module.exports = __webpack_public_path__ + "static/img/heyWhale_index_icon02.d54e3fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/heyWhale_index_icon02.png
// module id = Birn
// module chunks = 0